module.exports = __webpack_public_path__ + "media/loading-screens/butternut-box-and-yellow-heart-illustration--sprite-91b9d231.svg";